import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

export interface CannotUnbridgeDialogContext {
}

@Component({
    selector: "my-telegram-cannot-unbridge",
    templateUrl: "./cannot-unbridge.component.html",
    styleUrls: ["./cannot-unbridge.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class TelegramCannotUnbridgeComponent {

    constructor(public modal: NgbActiveModal) {
    }
}
